import script from "./InviteMemberInputs.vue?vue&type=script&setup=true&lang=ts"
export * from "./InviteMemberInputs.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__